import "./header.css"
import * as React from 'react';
import PropTypes from 'prop-types';
import { Container, Row, Col} from 'react-bootstrap';
import Logo_B_blanc from "../../Asset/Images/Logo_B_blanc.png"
import {languageCodeMapper} from '../../components/space/translationCodeMapper';

function Header(props) {
    // var userLang = navigator.language || navigator.userLanguage; 
    // console.log("userLang from browser",userLang);

    // const trustBuilderlangCode = languageCodeMapper(props.langCode)

    // const languageCode = 
    console.log("props in Header",props.isPrivate)

    return (
        <Container fluid className="container-fluid-header">
            <Row>
            <Col md={2} sm={3} xs={3} xxs={4} className="col-logo">
                    <div className="container-headerlogo">
                        <img className={props.isPrivate && props.isFormPage ? "image-headerlogo-FMO" : "image-headerlogo"} width={45} height={30} src={Logo_B_blanc} alt="FMS Logo" role="presentation" />
                    </div>
                </Col>
                <Col  md={8} sm={6} xs={6} xxs={4} className="col-title">
                {   !props.disableFMSTitle && <label className="label-fmsTitle">{props.isPrivate ? 'FixMyOffice' : 'FixMyStation'}</label>}
                </Col>
                <Col md={2} sm={3} xs={3} xxs={4} className="col-dropdown">
                { !props.disableDropDown && <Container fluid className="container-languageDropdown">
                    <select className="form-select-dropdown" role="dropDown"
                            onChange={(e) => props.handledropdown(e)}
                            name="LanguageDropdown"
                            // selected={langCode}
                            defaultValue={props.langCode}
                            >
                            <option value className="first-option"></option>
                            <option className="lang-option" value="EN">EN</option>
                            <option className="lang-option" value="NL">NL</option>
                            <option className="lang-option" value="FR">FR</option>
                            <option className="lang-option" value="DE">DE</option>
                        </select>   
                    </Container>}
                </Col>
            </Row>
        </Container>

    );
}

Header.propTypes = {
    isPrivate: PropTypes.bool,
    isFormPage: PropTypes.bool,
    disableFMSTitle: PropTypes.bool,
    disableDropDown: PropTypes.bool,
    handledropdown: PropTypes.func,
    langCode: PropTypes.string,
};

export default Header;
